import { request } from '@toolbox/utils';

type PostalCodeInfoResponse = {
  cities?: string[];
  code?: string;
  country?: string;
  valid: boolean;
};

export async function fetchPostalCodeInfo(code: string): Promise<PostalCodeInfoResponse> {
  try {
    return await request<PostalCodeInfoResponse>(
      `/api-geo/geography/postalCodeInfo?postalcode=${code}`,
    );
  } catch {
    return { valid: false };
  }
}
